import _createForOfIteratorHelper from "@babel/runtime/helpers/createForOfIteratorHelper";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { unblock } from "../../api";
import { OPT_IN_CONTENT_BLOCKER } from "../../types";
var APIS = ["youtube", "vimeo"];
/**
 * Overwrite the video API of elementor to make it GDPR compliant. It also implements
 * auto-play mechanism when clicking the content blocker.
 *
 * @see https://github.com/elementor/elementor/pull/12567
 * @see https://git.io/Js1em
 * @see https://git.io/Js1Eu
 */

function overwriteElementorVideoApi() {
  var w = window;
  var jQuery = w.jQuery;
  jQuery === null || jQuery === void 0 ? void 0 : jQuery(window).on("elementor/frontend/init", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var elementorFrontend, handlerWait, handler, onInit;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            elementorFrontend = w.elementorFrontend; // Override Video API's and check for consent

            elementorFrontend.on("components:init", function () {
              var _iterator = _createForOfIteratorHelper(APIS),
                  _step;

              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  var apiName = _step.value;
                  var api = elementorFrontend.utils[apiName];

                  if (api) {
                    api.insertAPI = function () {
                      var _this = this;

                      var apiUrl = this.getApiURL();
                      unblock(apiUrl).then(function () {
                        _this.elements.$firstScript.before(jQuery("<script>", {
                          src: apiUrl
                        }));
                      });
                      this.setSettings("isInserted", true);
                    };
                  }
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
            }); // Implement auto play

            handlerWait = elementorFrontend.elementsHandler.getHandler("video.default");

            if (!handlerWait) {
              _context2.next = 14;
              break;
            }

            if (!(handlerWait !== null && handlerWait !== void 0 && handlerWait.then)) {
              _context2.next = 10;
              break;
            }

            _context2.next = 7;
            return handlerWait;

          case 7:
            _context2.t0 = _context2.sent;
            _context2.next = 11;
            break;

          case 10:
            _context2.t0 = handlerWait;

          case 11:
            handler = _context2.t0;
            onInit = handler.prototype.onInit; // `onInit` is called for each video element, event it is blocked

            handler.prototype.onInit = function () {
              var $element = this.$element;
              $element === null || $element === void 0 ? void 0 : $element.get(0).addEventListener(OPT_IN_CONTENT_BLOCKER, /*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
                  var gotClicked, settings;
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          gotClicked = _ref2.detail.gotClicked;

                          if (gotClicked) {
                            settings = $element.data("settings");
                            settings.autoplay = true;
                            $element.data("settings", settings);
                          }

                        case 2:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x) {
                  return _ref3.apply(this, arguments);
                };
              }());

              for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
              }

              return onInit.apply(this, args);
            };

          case 14:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })));
}

export { overwriteElementorVideoApi };